import { render } from "./EntitiesPage.vue?vue&type=template&id=c353e50e"
import script from "./EntitiesPage.vue?vue&type=script&lang=js"
export * from "./EntitiesPage.vue?vue&type=script&lang=js"

import "./EntitiesPage.vue?vue&type=style&index=0&id=c353e50e&lang=scss"
script.render = render

export default script